import { Text } from '@chakra-ui/react';
import type React from 'react';

/**
 * What a viewer reads where an admin gets a button. A sentence, deliberately not
 * a disabled button with a tooltip.
 */
export const MigrationHelperText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Text fontSize="sm" color="fg.muted">
    {children}
  </Text>
);
